import { createSelector } from 'reselect';

import { isShareEnterpriseSecurityActive } from '@iconik-io/shared-lib/src/utils/is_enterprise_security_active';

import {
  SHARE_ASSET_PAGE_ROUTE,
  SHARE_ASSET_VERSION_PAGE_ROUTE,
  SHARE_COLLECTION_PAGE_ROUTE,
  SHARE_PORTAL_MEDIA_PAGE_ROUTE,
  SHARE_PORTAL_PAGE_ROUTE,
  SHARE_ROOT_ROUTE,
} from '../../constants/routes';
import type { AppState } from '../../store/types';
import { SHARE_USER_EMAIL_PLACEHOLDER } from './constants';

const getRoute = (state: AppState) => state.routeParams.route;

const shareRoutes = [
  SHARE_ASSET_PAGE_ROUTE,
  SHARE_ASSET_VERSION_PAGE_ROUTE,
  SHARE_COLLECTION_PAGE_ROUTE,
  SHARE_PORTAL_PAGE_ROUTE,
  SHARE_PORTAL_MEDIA_PAGE_ROUTE,
];

export const selectIsSharePage = createSelector(getRoute, (route) =>
  shareRoutes.includes(route),
);

const getShare = (state: AppState) => state.share.share;

const getMergedSettings = (state: AppState) => state.settings.merged;

/**
 * Whether the share's media is DRM protected or forensically watermarked.
 * Checked at view time rather than at share creation so shares made before
 * either was switched on are covered too. False off a share route, since
 * `share.share` is never cleared once a share has loaded.
 */
export const selectIsShareMediaProtected = createSelector(
  selectIsSharePage,
  getShare,
  getMergedSettings,
  (isSharePage, share, settings) =>
    isSharePage &&
    Boolean(share.id) &&
    isShareEnterpriseSecurityActive(share, settings),
);

const getShareToken = (state: AppState) => state.share.shareAuthLogin;

export const selectIsEmailAuthorizationNeeded = createSelector(
  getRoute,
  getShareToken,
  (route, shareToken) =>
    shareToken?.email === SHARE_USER_EMAIL_PLACEHOLDER &&
    route.startsWith(SHARE_ROOT_ROUTE),
);
